module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst attributes = (resourceData || {}).attributes || {}\nconst projectTerm = attributes.projectTerm || {}\nlet groupTitle = ''\nif(projectTerm.projectTermID){\ngroupTitle = 'UNKNOWN_DATE'\nif(projectTerm.startTS){\ngroupTitle = utils.moment(projectTerm.startTS).format('DD.MM.YYYY')\n}\nif(projectTerm.projectTermID){\ngroupTitle = `${groupTitle} - #${projectTerm.projectTermID}`\n}\nif(projectTerm.title){\ngroupTitle = `${groupTitle} - ${projectTerm.title}`\n}\nif(projectTerm.location){\ngroupTitle = `${groupTitle} - ${projectTerm.location}`\n}\n} else if(attributes.type === 'customFlat'){\ngroupTitle = storage.__('table.costCenters.additionalCostCenters')\n}\n%>\n<tbody>\n<tr>\n<td colspan=\"<%= config.maxNrOfColumns %>\">\n<div class=\"groupTitle\">\n<%= groupTitle %>\n</div>\n</td>\n</tr>\n</tbody>"
  , __filename = "components/templates/core/documents/table/groupRow.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const attributes = (resourceData || {}).attributes || {}
const projectTerm = attributes.projectTerm || {}
let groupTitle = ''
if(projectTerm.projectTermID){
groupTitle = 'UNKNOWN_DATE'
if(projectTerm.startTS){
groupTitle = utils.moment(projectTerm.startTS).format('DD.MM.YYYY')
}
if(projectTerm.projectTermID){
groupTitle = `${groupTitle} - #${projectTerm.projectTermID}`
}
if(projectTerm.title){
groupTitle = `${groupTitle} - ${projectTerm.title}`
}
if(projectTerm.location){
groupTitle = `${groupTitle} - ${projectTerm.location}`
}
} else if(attributes.type === 'customFlat'){
groupTitle = storage.__('table.costCenters.additionalCostCenters')
}

    ; __line = 22
    ; __append("\n<tbody>\n<tr>\n<td colspan=\"")
    ; __line = 25
    ; __append(escapeFn( config.maxNrOfColumns ))
    ; __append("\">\n<div class=\"groupTitle\">\n")
    ; __line = 27
    ; __append(escapeFn( groupTitle ))
    ; __append("\n</div>\n</td>\n</tr>\n</tbody>")
    ; __line = 31
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/table/groupRow.ejs

}